module.exports = __webpack_public_path__ + "static/assets/541f59e97aaa9ec9e790289498cf65dc.svg";